import React from 'react';

import { TAttributeListType, TChangedAssetProfile } from '@interfaces/assets/assetHistory';

import { availabilityCards, statusCards } from './constants';

import { getField } from '../util';

import AttributeCard from './AttributeCardChanged/AttributeCardChanged';

import styles from './Attributes.module.scss';

type TChangedType = {
	current: string;
	previous: string;
	isChanged: boolean;
	testId?: string;
};

//export for testing purposes
export const getStatusValue = (statusItem: Record<string, any>, num: Record<string, any>): TChangedType | null => {
	if (!statusItem) return null;

	const current = statusItem?.current;
	const previous = statusItem?.previous;

	return {
		current: num[current],
		previous: num[previous],
		isChanged: statusItem.isChanged,
		testId: statusItem.testId,
	};
};

const Attributes = ({ profile }: { profile: TChangedAssetProfile }) => {
	const getCardStatusList = (asset: TChangedAssetProfile, statusList: TAttributeListType[]) => {
		return statusList.map((item: TAttributeListType, key) => {
			const field = getField(asset, item.statusName as string);
			const options = getStatusValue(field as Record<string, any>, item.options);
			const detailsName = getField(asset, item.detailsName);
			const fileFieldName = getField(asset, item.fileFieldName, false);

			return (
				options && (
					<AttributeCard
						key={`card-${key}-${item.statusName}`}
						detailsName={detailsName}
						fileFieldName={fileFieldName}
						options={options || {}}
						title={item.title}
					/>
				)
			);
		});
	};

	const statusCardList = getCardStatusList(profile, statusCards);
	const availabilityCardList = getCardStatusList(profile, availabilityCards);

	return (
		<>
			<div className={styles.attributesContainer}>
				<div>{statusCardList}</div>
				<div>{availabilityCardList}</div>
			</div>
		</>
	);
};

export default Attributes;
